<template>
<Breadcrumbs main="Card" title="Card management" />

<!-- Loading Overlay -->
<LoadingOverlay :show="isLoading" message="Loading..." />

<div  class="card-filter-container">
    <div v-if="!filterVisible" class="filter-toggle-icon" @click="toggleFilter" >
        <i class="fa fa-search"></i>
    </div>
    <div v-else >
        <div class="filter-header" >
            <button class="btn btn-toggle" @click="toggleFilter"><i class="fa fa-times"></i></button>
        </div>
        <div class="filter-content">
        <div class="filter-form">
       <div class="row d-flex">
        <div class="col">
            <label>EAID</label>
            <input type="text" class="form-control" v-model="filterForm.eaid"></input>
        </div>
        <div class="col">
            <label>Driver ID</label>
            <input type="text" class="form-control" v-model="filterForm.driverId"></input>
        </div>
        <div class="col">
            <label>Driver name</label>
            <input type="text" class="form-control" v-model="filterForm.driverName"></input>
        </div>
        <div class="col">
            <label>Email</label>
            <input type="text" class="form-control" v-model="filterForm.email"></input>
        </div>
       </div>
       <div class="row d-flex">
        <div class="col"> 
            <label>Mobile</label>
            <input type="text" class="form-control" v-model="filterForm.mobile"></input>
        </div>
        <div class="col">
            <label>Card status</label>
            <select class="form-control" v-model="filterForm.cardStatus">
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
                <option value="lost_or_stolen">Lost or stolen</option>
                <option value="closed">Closed</option>
                <option value="eml_inactive">Eml_inactive</option>
            </select>
        </div>
        <div class="col">
            <label>Application type</label>
            <select class="form-control" v-model="filterForm.applicationType">
                <option value="">All</option>
                <option value="0">Online</option>
                <option value="1">Office</option>
            </select>
        </div>
        <div class="col">
            <label>Months to expiration</label>
            <select class="form-control" v-model="filterForm.months_to_expiration">
                <option value="">All</option>
                <option value="1">1 month</option>
                <option value="2">2 months</option>
                <option value="3">3 months</option>
                <option value="4">4 months</option>
            </select>
        </div>
       </div>
    </div>
   <div class="filter-button">
    <button class="btn btn-reset" @click="handleReset">Reset</button>
    <button class="btn btn-search" @click="handleSearch">Search</button>
   </div>
</div>
    </div>
    
</div>

<div class="card-table-container">
    <div class="card-table-header">
        <span class="selected-count">Selected: {{ selectedCount }}</span>
        <button class="download-button"@click="downloadCardPerformance"> 
            Download selected reports
            <i class="bi bi-download ms-2"></i>
        </button>
        <button class="refresh-button" @click="handleRefresh">
            Refresh
            <img src="@/assets/images/icon/refresh.svg" alt="refresh" class="refresh-icon ms-2">
        </button>
        <div class="select-all-checkbox">
            <label>Select all</label>
            <input 
                type="checkbox" 
                class="form-check-input"
                :checked="isAllSelected"
                @change="toggleSelectAll"
            >
        </div>
    </div>
    <div class="card-table-body">
        <div class="table-responsive signal-table">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th @click="handleSort('created')" :class="['sortable', { active: sortState.column === 'created' }]">
                            <span>Created</span>
                            <i v-if="sortState.column === 'created' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'created' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('startDate')" :class="['sortable', { active: sortState.column === 'startDate' }]">
                            <span>Start date</span>
                            <i v-if="sortState.column === 'startDate' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'startDate' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('lastUpdated')" :class="['sortable', { active: sortState.column === 'lastUpdated' }]">
                            <span>Last updated</span>
                            <i v-if="sortState.column === 'lastUpdated' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'lastUpdated' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('verification')" :class="['sortable', { active: sortState.column === 'verification' }]">
                            <span>Verification status</span>
                            <i v-if="sortState.column === 'verification' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'verification' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('eaid')" :class="['sortable', { active: sortState.column === 'eaid' }]">
                            <span>EAID</span>
                            <i v-if="sortState.column === 'eaid' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'eaid' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('assigned')" :class="['sortable', { active: sortState.column === 'assigned' }]">
                            <span>Assigned to</span>
                            <i v-if="sortState.column === 'assigned' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'assigned' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('appType')" :class="['sortable', { active: sortState.column === 'appType' }]">
                            <span>App type</span>
                            <i v-if="sortState.column === 'appType' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'appType' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('balance')" :class="['sortable', { active: sortState.column === 'balance' }]">
                            <span>Balance</span>
                            <i v-if="sortState.column === 'balance' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'balance' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th @click="handleSort('status')" :class="['sortable', { active: sortState.column === 'status' }]">
                            <span>Status</span>
                            <i v-if="sortState.column === 'status' && sortState.order === 'asc'" class="fa fa-sort-asc sort-icon"></i>
                            <i v-else-if="sortState.column === 'status' && sortState.order === 'desc'" class="fa fa-sort-desc sort-icon"></i>
                            <i v-else class="fa fa-sort sort-icon muted"></i>
                        </th>
                        <th>
                            <span>Report</span>
                        </th>
                        <th>
                            <span>View</span>
                        </th>
                        <th>
                            <span>Select</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="cards.length === 0">
                        <td :colspan="13" class="empty-placeholder">No data</td>
                    </tr>
                    <tr v-for="(card, index) in cards" :key="card.id || index">
                        <td>{{ formatDate(card.created_at) }}</td>
                        <td>{{ formatDate(card.start_date) }}</td>
                        <td>{{ formatDate(card.updated_at) }}</td>
                        <td>{{ card.eml_account_data?.verification ? 'Yes' : 'No' }}</td>
                        <td>{{ card.EAID || '-' }}</td>
                        <td>{{ card.driver?.assigned_to || '-' }}</td>
                        <td>{{ getAppType(card.app_type) }}</td>
                        <td>{{ formatCurrency(card.eml_account_data?.balance) }}</td>
                        <td>{{ card.status || 'Active' }}</td>
                        <td>
                            <img 
                                src="@/assets/svg/download.svg" 
                                alt="download" 
                                @click="downloadSingleCard(card)"
                                style="cursor: pointer;"
                            />
                        </td>
                        <td>
                            <img 
                                :src="card.isViewing ? viewIcon : eyeIcon"
                                @click="showAccountProfile(card)" 
                                alt="view"
                                style="cursor: pointer;"
                            />
                        </td>
                        <td class="select-all-checkbox">
                            <input 
                                type="checkbox" 
                                class="form-check-input" 
                                :checked="card.selected"
                                @change="toggleCardSelection(card, $event)"
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <div>
                <div class="pagination-container">
                 <div class="pagination-wrapper">
                    <div @click="changePage(1)" style="cursor: pointer;"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></div>
                    <div class="pagination-left" @click="changePage(Math.max(1, currentPage - 1))" style="cursor: pointer;"> <img src="@/assets/images/admin/arrow/prev.png" alt="prev" style="width: 25px; height: 25px;" > </div>
                    <span>
              Page
              <input type="number" style="width: 60px;" v-model.number="currentPageInput" @change="changePage(currentPageInput)" min="1" :max="Math.ceil(totalEntries / cardStore.itemsPerPage) || 1" />

              of {{ Math.ceil(totalEntries / cardStore.itemsPerPage) || 1 }}
            </span>
                    <div class="pagination-right" @click="changePage(Math.min(Math.ceil(totalEntries / cardStore.itemsPerPage) || 1, currentPage + 1))" style="cursor: pointer;"> <img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /> </div>
                    <div @click="changePage(Math.ceil(totalEntries / cardStore.itemsPerPage) || 1)" style="cursor: pointer;"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></div>
                </div>
                <div>
                    <p>Displaying cards {{ (currentPage - 1) * cardStore.itemsPerPage + 1 }} - {{ Math.min(currentPage * cardStore.itemsPerPage, totalEntries) }} of {{ totalEntries }}</p>
                </div>
                </div>
</div>
        </div>
    </div>
</div>

<!-- Account Profile Modal -->
<div class="modal fade" ref="accountProfileModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl modal-dialog-centered account-profile-modal-dialog" role="document">
        <div class="modal-content">
            <AccountProfile v-if="isViewMode" :driver_id="selectedDriverId" :eaid="selectedEaid" @close="hideAccountProfile" />
        </div>
    </div>
</div>

</template>
<script setup>
import { ref, onMounted, computed, onBeforeUnmount, nextTick, reactive } from 'vue';
import { Modal } from 'bootstrap';
import { useCardStore} from '@/store/admin/card';
import eyeIcon from '@/assets/svg/eye.svg';
import viewIcon from '@/assets/svg/View.svg';
import AccountProfile from './accountProfile.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import { formatDateDetailed, formatAmount } from '@/utils/formatters';
import Swal from 'sweetalert2';

const cardStore = useCardStore();
const isViewMode = ref(false);
const accountProfileModal = ref(null);
const selectedDriverId = ref(null);
const selectedEaid = ref(null);
const viewingCardId = ref(null); // 記錄當前正在查看的卡片 ID
const isLoading = ref(false); // Loading 狀態
let modalInstance = null;

// 篩選表單資料
const filterForm = reactive({
  eaid: '',
  driverId: '',
  driverName: '',
  email: '',
  mobile: '',
  cardStatus: '',
  applicationType: '',
  months_to_expiration: ''
});



const downloadCardPerformance = async () => {
    try{
        // 獲取選中的卡片
        const selectedCards = cards.value.filter(card => card.selected);
        
        
       
        const driverIds = selectedCards
            .map(card => card.driver?.driver_id)  
            .filter(id => id); 
        
        const payload = {
            driver_id: driverIds  
        };
        
        await cardStore.downCardPerformance(payload);
        
       
    }
    catch(error){
        console.error('Error downloading card performance:', error);
        Swal.fire({
            icon: 'error',
            title: 'Download Failed',
            text: error.message || 'Failed to download card performance',
            confirmButtonText: 'OK'
        });
    }
}

// 下載單個卡片資料
const downloadSingleCard = async (card) => {
    try {
        const driverId = card.driver?.driver_id;
        
        const payload = {
            driver_id: [driverId]  
        };
        
        await cardStore.downCardPerformance(payload);
        
      
    } catch (error) {
        console.error('Error downloading single card:', error);
        Swal.fire({
            icon: 'error',
            title: 'Download Failed',
            text: error.message || 'Failed to download card data',
            confirmButtonText: 'OK'
        });
    }
};



const showAccountProfile = async (card) => {
    // 設置 driver_id
    selectedDriverId.value = card.driver?.id || null;
    selectedEaid.value = card.EAID ?? card.eaid ?? null;
    // 記錄當前正在查看的卡片 ID
    viewingCardId.value = card.id || card.driver?.id || null;
    isViewMode.value = true;
    await nextTick();
    await nextTick(); // 確保 AccountProfile 組件已渲染
    if (!modalInstance && accountProfileModal.value) {
        try {
            modalInstance = new Modal(accountProfileModal.value);
        } catch (error) {
            console.error('初始化 Modal 失敗:', error);
            return;
        }
    }
    if (modalInstance) {
        modalInstance.show();
    }
};

const hideAccountProfile = () => {
    isViewMode.value = false;
    selectedEaid.value = null;
    viewingCardId.value = null; // 清除查看狀態
    if (modalInstance) {
        modalInstance.hide();
    }
};

onBeforeUnmount(() => {
    if (modalInstance) {
        modalInstance.dispose();
    }
});



const filterVisible = ref(false);
const sortState = ref({
    column: '',
    order: 'asc'
});

// 獲取應用類型
const getAppType = (enabled) => {
   if(enabled == 0)
   {
    return 'Online';
   }else
   return 'Office';
};

const toggleFilter = () => {
    filterVisible.value = !filterVisible.value;
};

const handleSort = (column) => {
    if (sortState.value.column === column) {
        sortState.value.order = sortState.value.order === 'asc' ? 'desc' : 'asc';
    } else {
        sortState.value.column = column;
        sortState.value.order = 'desc';
    }
};

// 連接 cardStore 的資料並實現排序
const cards = computed(() => {
    let cardList = cardStore.cards || [];
    
    // 為每個卡片添加 isViewing 屬性
    cardList = cardList.map(card => ({
        ...card,
        isViewing: viewingCardId.value === (card.id || card.driver?.id)
    }));
    
    // 如果有排序狀態，進行排序
    if (sortState.value.column) {
        const sortedList = [...cardList];
        const order = sortState.value.order === 'asc' ? 1 : -1;
        
        sortedList.sort((a, b) => {
            let aValue, bValue;
            
            switch (sortState.value.column) {
                case 'created':
                    aValue = new Date(a.created_at || 0).getTime();
                    bValue = new Date(b.created_at || 0).getTime();
                    break;
                case 'startDate':
                    aValue = new Date(a.start_date || 0).getTime();
                    bValue = new Date(b.start_date || 0).getTime();
                    break;
                case 'lastUpdated':
                    aValue = new Date(a.updated_at || 0).getTime();
                    bValue = new Date(b.updated_at || 0).getTime();
                    break;
                case 'verification':
                    aValue = (a.eml_account_data?.verification ? 'Yes' : 'No').toLowerCase();
                    bValue = (b.eml_account_data?.verification ? 'Yes' : 'No').toLowerCase();
                    break;
                case 'eaid':
                    aValue = (a.EAID || '').toLowerCase();
                    bValue = (b.EAID || '').toLowerCase();
                    break;
                case 'assigned':
                    aValue = (a.driver?.assigned_to || '').toLowerCase();
                    bValue = (b.driver?.assigned_to || '').toLowerCase();
                    break;
                case 'appType':
                    aValue = (getAppType(a.enabled) || '').toLowerCase();
                    bValue = (getAppType(b.enabled) || '').toLowerCase();
                    break;
                case 'balance':
                    aValue = parseFloat(a.eml_account_data?.balance) || 0;
                    bValue = parseFloat(b.eml_account_data?.balance) || 0;
                    break;
                case 'status':
                    aValue = (a.status || 'Active').toLowerCase();
                    bValue = (b.status || 'Active').toLowerCase();
                    break;
                default:
                    return 0;
            }
            
            if (aValue < bValue) return -1 * order;
            if (aValue > bValue) return 1 * order;
            return 0;
        });
        
        return sortedList;
    }
    
    return cardList;
});
const totalEntries = computed(() => cardStore.totalEntries || 0);
const currentPage = computed(() => cardStore.currentPage || 1);
const currentPageInput = ref(1);

// 計算選中的卡片數量
const selectedCount = computed(() => {
    if (!cards.value || !Array.isArray(cards.value)) {
        return 0;
    }
    return cards.value.filter(card => card.selected).length;
});

// 計算是否全選
const isAllSelected = computed(() => {
    if (!cards.value || cards.value.length === 0) {
        return false;
    }
    return cards.value.every(card => card.selected);
});

// 切換全選
const toggleSelectAll = (event) => {
    const isChecked = event.target.checked;
    // 直接修改 store 中的資料
    if (cardStore.cards && Array.isArray(cardStore.cards)) {
        cardStore.cards.forEach(card => {
            card.selected = isChecked;
        });
    }
};

// 切換單個卡片的選中狀態
const toggleCardSelection = (card, event) => {
    const isChecked = event.target.checked;
    // 找到 store 中對應的卡片並更新
    if (cardStore.cards && Array.isArray(cardStore.cards)) {
        const storeCard = cardStore.cards.find(c => 
            (c.id && c.id === card.id) || 
            (c.driver?.id && c.driver.id === card.driver?.id) ||
            (c.EAID && c.EAID === card.EAID)
        );
        if (storeCard) {
            storeCard.selected = isChecked;
        }
    }
};

// 載入資料的共用函數
const loadCards = async (params = {}) => {
    try {
        isLoading.value = true; // 開始 loading
        // 默認每頁 10 筆
        const requestParams = {
            ...params,
            per_page: 10
        };
        
        await cardStore.fetchCards(requestParams);
        // 確保每個卡片都有 selected 屬性
        if (cardStore.cards && Array.isArray(cardStore.cards)) {
            cardStore.cards.forEach(card => {
                if (card.selected === undefined) {
                    card.selected = false;
                }
            });
        }
        currentPageInput.value = cardStore.currentPage;
    } catch (error) {
        console.error('載入卡片資料失敗:', error);
    } finally {
        isLoading.value = false; // 結束 loading
    }
};

// 刷新資料
const handleRefresh = async () => {
    isLoading.value = true; // 開始 loading
    try {
        // 保留當前篩選條件重新載入
        await loadCards({ ...currentFilters.value, page: currentPage.value });
    } finally {
        isLoading.value = false; // 結束 loading
    }
};

// 儲存當前的篩選參數
const currentFilters = ref({});

// 搜尋功能
const handleSearch = async () => {
    const searchParams = {};
    
  
    if (filterForm.eaid) searchParams.eaid = filterForm.eaid;
    if (filterForm.driverId) searchParams.driver_id = filterForm.driverId;
    if (filterForm.driverName) searchParams.driver_name = filterForm.driverName;
    if (filterForm.email) searchParams.email = filterForm.email;
    if (filterForm.mobile) searchParams.mobile = filterForm.mobile;
    if (filterForm.cardStatus !== '') searchParams.status = filterForm.cardStatus;
    if (filterForm.applicationType !== '') searchParams.app_type = filterForm.applicationType;
    if (filterForm.months_to_expiration !== '') searchParams.months_to_expiration = filterForm.months_to_expiration;
    
    // 儲存當前篩選條件
    currentFilters.value = { ...searchParams };
    
    // 搜尋時回到第一頁
    await loadCards({ ...searchParams, page: 1 });
};

// 重置篩選條件
const handleReset = () => {
    filterForm.eaid = '';
    filterForm.driverId = '';
    filterForm.driverName = '';
    filterForm.email = '';
    filterForm.mobile = '';
    filterForm.cardStatus = '';
    filterForm.applicationType = '';
    filterForm.months_to_expiration = '';
    
    // 清空篩選條件
    currentFilters.value = {};
    
    // 重置後重新載入資料（回到第一頁）
    loadCards({ page: 1 });
};


// 載入資料
onMounted(async () => {
    await loadCards({ page: 1 });
});

// 分頁處理
const changePage = async (page) => {
    const totalPages = Math.ceil(totalEntries.value / cardStore.itemsPerPage) || 1;
    
    if (page >= 1 && page <= totalPages) {
        currentPageInput.value = page;
        // 重新載入資料，保留當前的篩選條件
        await loadCards({ ...currentFilters.value, page });
    }
};

// 使用工具函數 formatDateDetailed 和 formatAmount（已從 @/utils/formatters 導入）
const formatDate = formatDateDetailed;

// 格式化貨幣（使用 formatAmount）
const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '-';
    return formatAmount(amount);
};
</script>
<style scoped> 
.card-filter-container{
    background-color: white;
    margin:0px 70px;
    padding: 20px;
    border-radius: 5px;
   
   
}
.filter-toggle-icon{
    font-size: 24px;
    cursor: pointer;
    display: flex;
    justify-content:flex-end;
    align-items: center;
}

.btn-toggle {
  background: none;
  border: none;
  color: black;
  font-size: 24px;
  cursor: pointer;
 
}
.filter-content{
    display:flex;
}
.filter-header{
    display: flex;
    justify-content:flex-end;
    align-items: center;
}
.filter-form{
   flex:0 0 85%;
}
.filter-button{
    flex:0 0 15%;
    display:flex;
    flex-direction:column;
    justify-content:flex-end;
    align-items:center;
    gap:10px ;
}
.btn-reset{
    width: 50%;
    height: 46px;
    border-radius: 30px;
    border: 2px solid #00C962;
    background-color: white;
    color:black;
}
.btn-search{
    width: 50%;
    height: 46px;
    border-radius: 30px;
    background-color: #00C962;
    color: black;
}

.card-table-container{
    background-color:white;
    margin:0px 70px;
    margin-top:20px;
    border-radius:5px;
    padding:20px 20px 30px;
    box-shadow:0 2px 4px rgba(0,0,0,0.08);
}

.card-table-header{
    display:flex;
    justify-content:flex-end;
    align-items:center;
    gap:12px;
    flex-wrap:wrap;
    margin-bottom:16px;
}
.selected-count{
    font-weight:600;
}
.download-button{
    color:black;
    background-color: #00C962;
    border-radius:30px;
    padding:10px 20px;
    border:none;
    display:flex;
    align-items:center;
    gap:8px;
}
.refresh-button{
    color:black;
    background-color:white;
    border:2px solid #00C962;
    border-radius:30px;
    padding:10px 20px;
    display:flex;
    align-items:center;
    gap:8px;
}
.refresh-icon{
    width: 15px;
    height: 15px;
}
.card-table-body .table{
    margin-bottom:0;
}
.card-table-body thead th{
    font-size:12px;
    font-weight:600;
    color:#667085;
    border-bottom:1px solid #e4e7ec;
    text-transform:uppercase;
    padding-bottom:12px;
}
.card-table-body thead th.sortable{
    cursor:pointer;
    position:relative;
}
.card-table-body thead th .sort-icon{
    margin-left:6px;
    font-size:14px;
    color:#98a2b3;
}
.card-table-body thead th .sort-icon.muted{
    opacity:0.4;
}
.card-table-body thead th.sortable.active{
    color:#00C962;
}
.card-table-body thead th.sortable.active::after{
    content:'';
    position:absolute;
    left:0;
    bottom:0;
    width:100%;
    height:2px;
    background-color:#00C962;
}
.card-table-body tbody td{
    vertical-align:middle;
    text-align:center;
}
.empty-placeholder{
    text-align:center;
    color:#98a2b3;
    padding:24px 0;
}
.select-all-checkbox{
    display:flex;
    align-items:center;
    gap:8px;
}
.select-all-checkbox input[type="checkbox"]{
    border:2px solid #00C962;
    border-radius:3px;
    width: 26px;
    height: 26px;
    position: relative;
    top:-6px;
}

.pagination-container{
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:10px;
    
    
}
.pagination-wrapper{
    display:flex;
    gap:10px;

}

/* Account Profile Modal 自定義寬度 - 參考 EditRefund 的實現方式 */
.account-profile-modal-dialog {
    max-width: 80%;
    width: 80%;
    max-height: 90vh;
}

.modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
}

.modal-body {
    flex-grow: 1;
    overflow-y: auto;
}

/* 響應式設計：在小螢幕上使用較小寬度 */
@media (max-width: 768px) {
    .account-profile-modal-dialog {
        max-width: 100%;
        width: 100%;
        height: 100vh;
        margin: 0;
    }

    .modal-content {
        height: 100%;
        border-radius: 0;
    }

    .modal-body {
        overflow-y: auto;
    }

    /* 篩選器容器 */
    .card-filter-container {
        margin: 0px 15px;
        padding: 15px;
    }

    /* 篩選表單 */
    .filter-content {
        flex-direction: column;
    }

    .filter-form {
        flex: 1;
        width: 100%;
    }

    .filter-form .row {
        flex-direction: column;
        margin-bottom: 15px;
    }

    .filter-form .col,
    .filter-form .col-2 {
        width: 100%;
        margin-bottom: 15px;
    }

    .filter-form label {
        font-size: 14px;
        margin-bottom: 5px;
        display: block;
    }

    .filter-form .form-control {
        width: 100%;
    }

    /* 篩選按鈕 */
    .filter-button {
        flex: 1;
        width: 100%;
        flex-direction: row;
        justify-content: center;
        margin-top: 15px;
    }

    .btn-reset,
    .btn-search {
        width: 48%;
        margin: 0 1%;
    }

    /* 表格容器 */
    .card-table-container {
        margin: 0px 15px;
        margin-top: 15px;
        padding: 15px;
    }

    /* 表格標題 */
    .card-table-header {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    .selected-count {
        width: 100%;
        text-align: center;
        margin-bottom: 5px;
    }

    .download-button,
    .refresh-button {
        width: 100%;
        justify-content: center;
        padding: 12px 20px;
        font-size: 14px;
    }

    .select-all-checkbox {
        width: 100%;
        justify-content: center;
        margin-top: 5px;
    }

    /* 表格容器 */
    .card-table-body .table-responsive {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .card-table-body .table {
        width: 100%;
        min-width: 1000px;
        table-layout: auto;
        border-collapse: collapse;
    }

    /* 表格標題文字 */
    .card-table-body thead th {
        font-size: 10px;
        padding: 8px 4px;
        white-space: nowrap;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
    }

    .card-table-body thead th span {
        display: inline-block;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        line-height: 1.2;
    }

    .card-table-body thead th .sort-icon {
        vertical-align: middle;
        margin-left: 4px;
        display: inline-block;
        line-height: 1;
    }

    /* 表格內容 */
    .card-table-body tbody td {
        font-size: 12px;
        padding: 8px 4px;
        white-space: nowrap;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
    }

    /* 確保每列的寬度一致 */
    .card-table-body .table th,
    .card-table-body .table td {
        width: auto;
    }

    .card-table-body tbody td img {
        width: 18px;
        height: 18px;
    }

    /* 分頁器 */
    .pagination-container {
        flex-direction: column;
        gap: 15px;
        align-items: center;
    }

    .pagination-wrapper {
        flex-wrap: wrap;
        justify-content: center;
        gap: 5px;
    }

    .pagination-wrapper img {
        width: 20px !important;
        height: 20px !important;
    }

    .pagination-wrapper span {
        font-size: 14px;
    }

    .pagination-wrapper input {
        width: 50px !important;
        font-size: 14px;
    }

    .pagination-container p {
        font-size: 12px;
        text-align: center;
    }
}

/* 小手機版 (小於 576px) */
@media (max-width: 576px) {
    .card-filter-container {
        margin: 0px 10px;
        padding: 10px;
    }

    .card-table-container {
        margin: 0px 10px;
        margin-top: 10px;
        padding: 10px;
    }

    .card-table-body thead th {
        font-size: 9px;
        padding: 6px 2px;
        text-align: center;
        vertical-align: middle;
    }

    .card-table-body thead th span {
        vertical-align: middle;
    }

    .card-table-body thead th .sort-icon {
        vertical-align: middle;
        margin-left: 3px;
    }

    .card-table-body tbody td {
        font-size: 11px;
        padding: 6px 2px;
        text-align: center;
        vertical-align: middle;
    }

    .download-button,
    .refresh-button {
        font-size: 12px;
        padding: 10px 15px;
    }

    .btn-reset,
    .btn-search {
        height: 40px;
        font-size: 14px;
    }
}
</style> 